import React from 'react'
import { useTranslation } from 'react-i18next'

import { useColumnToggle } from '../../../../hooks/useColumnToggle'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { convertDeliveryForecast } from '../../../../utils/wrapper/ConfigurableTable/convertData'
import { useConfigContext } from '../../../ui-config'
import { useAllDeliveryForecasts } from '../../data'

const TOGGLEABLE_FIELDS = [
  'Payload.Item.Position',
  'Payload.Item.Plant',
  'Payload.Item.UnloadingPoint',
  'Payload.Item.BuyerProductId',
  'Payload.Item.BuyerProductDescription',
  'Payload.CurrentReleaseNumber',
  'Payload.Item.CummulativeQuantityReceived',
  'Payload.Item.LastReceiving.Date',
]

const STORAGE_KEY = 'delivery-forecasts-visible-columns'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
  isVisible: boolean
}

export const DeliveryForecastsTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
  isVisible,
}) => {
  const { t } = useTranslation()

  const { data, isLoading, error } = useAllDeliveryForecasts()
  const { uiConfig: config } = useConfigContext()

  const tableConfig = config.deliveryForecasts.deliveryForecast.table

  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    tableConfig,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
  )

  return (
    <>
      <div hidden={!isVisible && (data === undefined || data.length < 1)}>
        {config.deliveryForecasts.deliveryForecast.enabled && (
          <div className="mt-0">
            <h3>{t('deliveryForecasts.deliveryForecasts.title')}</h3>

            <ConfigurableTable
              config={effectiveTableConfig}
              data={convertDeliveryForecast(data)}
              link={'delivery-forecasts/delivery-forecast'}
              globalFilterFields={['Payload.ScheduleAgreementNumber']}
              globalFilterValue={globalFilterValue}
              setGlobalFilterValue={setGlobalFilterValue}
              isLoading={isLoading}
              stateKey="table-delivery-forecast-delivery-forecasts"
              navigationColumnHeader={navigationColumnHeader}
            />
          </div>
        )}
      </div>
    </>
  )
}
